export default __webpack_public_path__ + "static/media/Upload.4baf7db0.svg";